<template>
    <div class="wrapBox">
      <el-tabs v-model="activeName"  @tab-click="handleClick" >
        <el-tab-pane label="概况" name="survey">
          <app-info-details v-if="activeName=='survey'"></app-info-details>
        </el-tab-pane>


        <el-tab-pane v-for="(item,index) in navList" :key="index" :label="item.name" :name="item.code">
          <app-standard-results  v-if="activeName==item.code" :standard = activeName :memberName = memberName></app-standard-results >
        </el-tab-pane>

        <!-- <el-tab-pane label="兼容性测试" name="compatible">
          <app-standard-results v-if="activeName=='compatible'" :standard = activeName :memberName = memberName></app-standard-results>
        </el-tab-pane>
        <el-tab-pane label="稳定性测试" name="stable">
          <app-standard-results v-if="activeName=='stable'" :standard = activeName :memberName = memberName></app-standard-results>
        </el-tab-pane>
        <el-tab-pane label="安全测试" name="security">
          <app-standard-results v-if="activeName=='security'" :standard = activeName :memberName = memberName></app-standard-results>
        </el-tab-pane>
        <el-tab-pane label="功耗测试" name="consumption">
          <app-standard-results v-if="activeName=='consumption'" :standard = activeName :memberName = memberName></app-standard-results>
        </el-tab-pane>
        <el-tab-pane label="性能测试" name="performance">
          <app-standard-results v-if="activeName=='performance'"  :standard = activeName  :memberName = memberName></app-standard-results>
        </el-tab-pane>
        <el-tab-pane label="大屏标准" name="large">
          <app-standard-results v-if="activeName=='large'"  :standard = activeName  :memberName = memberName></app-standard-results>
        </el-tab-pane> -->


      </el-tabs>
    </div>
</template>

<script>

import appStandardResults from './template/appStandardResults';
import appInfoDetails from "./template/appInfoDetails"
import store from '@/store/index.js';
export default {
  beforeRouteEnter: (to,from,next) => {
    store.commit("breadcrumbStore/setMenuBreadcrumb", {'menu': to.meta.menuBreadcrumb, name: to.query.breadcrumbName, path: to.fullPath} );
    next()
  },
  components: {appInfoDetails,appStandardResults},
  data(){
    return{
      activeName:"survey",
      navList:[]
    }
  },
  computed: {
    memberName() {
      let text='';
      switch (this.$route.query.memberId) {
        case 1:
          text = "小米"
          break;
        case 2:
          text = "OPPO"
          break;
        case 3:
          text = "vivo"
          break;
      }
      return text; 
    },
  },
   mounted(){
    this.queryStandardList()
  },
  methods: {
    handleClick(tab) {
      sessionStorage.setItem('standardTestReport_tab',tab.name);
    },
     queryStandardList(){
      this.$apis.unionDeployServer.queryStandardList().then(res=>{
        if (res['code'] == 0) {
          this.navList=res.data;
        }
      })
    },
  },
  activated(){
    if(sessionStorage.getItem('standardTestReport_tab')){
      this.activeName = sessionStorage.getItem('standardTestReport_tab')
    }
  },
  beforeRouteLeave(to, from, next){
    //返回上一页：  缓存上一页  不缓存当前页(释放缓存，方便数据重新加载) 
    if(to.name === 'attestDetails') {
      to.meta.keepAlive = true;
      from.meta.keepAlive = false;
    }
    //去下一页 缓存当前 在去下一页
    if(to.name === 'reportDetails') {
      from.meta.keepAlive = true;
    }
    next();
  }
};
</script>

<style scoped lang="scss">
.el-tabs {
  height: 100%;
  ::v-deep .is-active {
    font-weight:bolder ;
  }
}
</style>